import { render, staticRenderFns } from "./SchemeDetails.vue?vue&type=template&id=12991367&scoped=true"
import script from "./SchemeDetails.vue?vue&type=script&lang=js"
export * from "./SchemeDetails.vue?vue&type=script&lang=js"
import style0 from "./SchemeDetails.vue?vue&type=style&index=0&id=12991367&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12991367",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12991367')) {
      api.createRecord('12991367', component.options)
    } else {
      api.reload('12991367', component.options)
    }
    module.hot.accept("./SchemeDetails.vue?vue&type=template&id=12991367&scoped=true", function () {
      api.rerender('12991367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/components/SchemeDetails.vue"
export default component.exports